export default "__VITE_ASSET__BRq7RxgQ__"